export class MapPosition {
    /**
     * @param {Number|null} zoom
     * @param {Object|null} position
     * @param {Number} position.lat
     * @param {Number} position.lng
     */
    constructor(zoom = null, position = null) {
        this.zoom = zoom;
        this.position = position;
    }

    /**
     * @param data
     * @param {Number} data.zoom
     * @param {Object} data.position
     * @param {Number} data.position.lat
     * @param {Number} data.position.lng
     * @returns {MapPosition}
     */
    static create(data) {
        return Object.assign(
            new MapPosition(),
            data
        );
    }

    /**
     * @param {Number} zoom
     * @returns {MapPosition}
     */
    changeZoom(zoom) {
        return MapPosition.create({zoom, position: this.position});
    }

    /**
     * @param {Object} position
     * @param {Number} position.lat
     * @param {Number} position.lng
     * @returns {MapPosition}
     */
    changePosition(position) {
        return MapPosition.create({position, zoom: this.zoom});
    }
}
